import React from 'react';
import { Backdrop } from '@mui/material';
import LoadingAnimation from './LoadingAnimation';

const PageTransitionLoader = ({ open }) => (
  <Backdrop
    open={open}
    aria-busy={open}
    aria-label="Loading page"
    sx={{
      zIndex: (theme) => theme.zIndex.modal + 1,
      background: 'rgba(255, 255, 255, 0.98)',
    }}
  >
    <LoadingAnimation restart={open} />
  </Backdrop>
);

export default PageTransitionLoader;
